import { Action } from 'redux'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

const validateReservation = (tabs = [0]): IValidateReservation => ({
  tabs: tabs,
  type: ReservationModalActions.Validate,
})

export interface IValidateReservation
  extends Action<ReservationModalActions.Validate> {
  tabs?: number[]
}

export default validateReservation
